import React, { useState } from 'react';
import styled from 'styled-components';
import AboutUsModal from './AboutUsModal';
import GenericModal from './GenericModal';

const SettingsButton = styled.button`
  background-color: #f0f0f0;
  color: #000;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  padding: 15px;
  width: 100%;
  margin-bottom: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:last-of-type {
    margin-bottom: 0; /* Adjust if CopyIdSection is present */
  }
`;

const CopyIdSection = styled.div`
  text-align: center;
  margin-top: 20px; /* Spacing from the last button */
  color: #666;
  font-size: 14px;
`;

const SettingsModal = ({ isOpen, onClose, userId }) => {
  const [showAboutUs, setShowAboutUs] = useState(false);

  const handleCopyToClipboard = () => {
    if (navigator.clipboard && userId) {
      navigator.clipboard.writeText(userId);
      // Consider adding a brief message like "Copied!"
    }
  };

  return (
    <>
      <GenericModal
        isOpen={isOpen}
        onClose={onClose}
        title="Settings"
        zIndex={1000000}
        containerMaxWidth="350px"
        contentPadding="20px" // Standard padding for content
      >
        <SettingsButton disabled>
          <span role="img" aria-label="language">🌐</span> Language
        </SettingsButton>

        <SettingsButton onClick={() => setShowAboutUs(true)}>
          About Us
        </SettingsButton>

        {userId && (
          <CopyIdSection>
            {userId}
            <button
              onClick={handleCopyToClipboard}
              style={{ marginLeft: '10px', border: 'none', background: 'transparent', cursor: 'pointer', color: '#007bff' }}
              title="Copy User ID"
            >
              📋 Copy ID
            </button>
          </CopyIdSection>
        )}
      </GenericModal>

      {/* AboutUsModal is rendered separately and will appear on top due to its own zIndex */}
      <AboutUsModal isOpen={showAboutUs} onClose={() => setShowAboutUs(false)} />
    </>
  );
};

export default SettingsModal;
